module.exports = __webpack_public_path__ + "static/media/material-wrinkle-free.bb77ab63.svg";